import angular from 'angular';
import smsEditor from './smsEditor';
import recipientsList from './recipientsList';
import './style.scss';

export default angular
  .module('smsEditor', [])
  .component('smsEditor', smsEditor)
  .component('recipientsList', recipientsList).name;
